import Swiper, { Navigation, Pagination, Lazy } from 'swiper'
import 'swiper/swiper-bundle.css'
import './_swiper-gallery.scss'
import './_swiper-card.scss'
import './_swiper-news.scss'
import './_swiper-slider.scss'
import './_swiper-projects.scss'
import './_wide-slider.scss'

Swiper.use([Navigation, Pagination, Lazy])

const configs = {
  news: {
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
      loadOnTransitionStart: true,
    },
    preloadImages: false,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: '.news-button-next',
      prevEl: '.news-button-prev',
    },
    speed: 700,
    slidesPerView: 'auto',
  },
  gallery: {
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
      loadOnTransitionStart: true,
    },
    preloadImages: false,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: '.gallery-button-next',
      prevEl: '.gallery-button-prev',
    },
    pagination: {
      el: '.gallery-pagination',
      type: 'fraction',
    },
    speed: 700,
    slidesPerView: 'auto',
    centeredSlides: true,
  },
  wideSlider: {
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
      loadOnTransitionStart: true,
    },
    preloadImages: false,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: '.card-button-next',
      prevEl: '.card-button-prev',
    },
    pagination: {
      el: '.card-pagination',
      type: 'fraction',
    },
    speed: 800,
    slidesPerView: 'auto',
  },
  projects: {
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
      loadOnTransitionStart: true,
    },
    preloadImages: false,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: '.projects-button-next',
      prevEl: '.projects-button-prev',
    },
    speed: 700,
    slidesPerView: 'auto',
    centeredSlides: true,
  },
}

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return

    const el = entry.target
    let configKey
    if (el.classList.contains('swiper-news')) {
      configKey = 'news'
    } else if (el.classList.contains('swiper-gallery')) {
      configKey = 'gallery'
    } else if ('wideSlider' in el.dataset) {
      configKey = 'wideSlider'
    } else if (el.classList.contains('swiper-projects')) {
      configKey = 'projects'
    }
    if (configKey) {
      new Swiper(el, configs[configKey])
    }
    observer.unobserve(entry.target)
  })
})

export default page => {
  const selectors = [
    '.swiper-news',
    '.swiper-gallery',
    '[data-wide-slider]',
    '.swiper-projects',
  ]
  selectors.forEach(selector => {
    const element = page.querySelector(selector)
    if (element) {
      observer.observe(element)
    }
  })
}
